import * as THREE from "three";
import { FontLoader, Object3D, Vector3 } from "three";
import { GLTF } from "three/examples/jsm/loaders/GLTFLoader";
import SpriteText from 'three-spritetext';
import { MeshLine, MeshLineMaterial, MeshLineRaycast } from 'three.meshline';
import { Utils } from "./utils";
import threeSpritetext from "three-spritetext";

class ThreeUtils {

    public static getBBox(gltfscene): THREE.Box3 {

        var bbox = { min: { x: Infinity, y: Infinity, z: Infinity }, max: { x: -Infinity, y: -Infinity, z: -Infinity } };

        if (!gltfscene) return;

        gltfscene.traverse((child) => {
            if (child.type === "Object3D" || child.type == "Mesh") { // fenster: Object3D. regal: mesh
                var b = new THREE.Box3().setFromObject(child);
                if (b.min.x < bbox.min.x) bbox.min.x = b.min.x;
                if (b.min.y < bbox.min.y) bbox.min.y = b.min.y;
                if (b.min.z < bbox.min.z) bbox.min.z = b.min.z;
                if (b.max.x > bbox.max.x) bbox.max.x = b.max.x;
                if (b.max.y > bbox.max.y) bbox.max.y = b.max.y;
                if (b.max.z > bbox.max.z) bbox.max.z = b.max.z;

            }
        });

        var bb = new THREE.Box3(new Vector3(bbox.min.x, bbox.min.y, bbox.min.z), new Vector3(bbox.max.x, bbox.max.y, bbox.max.z));

        return bb;

    }

    public static async setTransformations(scene: any, calcultionmodel: any, baseGltf: any, param1, param2, param3, originalwidth = null, originalheight = null, originaldepth = null) {
        //  let copy = (baseGltf as any).clone();

        globalThis.calculationModel = calcultionmodel; // await (await fetch(modelfilename).then()).json(); // TODO: nur 1x laden
        var bbox = { min: { x: Infinity, y: Infinity, z: Infinity }, max: { x: -Infinity, y: -Infinity, z: -Infinity } };


        if (!calcultionmodel) {
            baseGltf.scale.x = param1 / originalwidth;
            baseGltf.scale.y = param2 / originalheight;
            baseGltf.scale.z = param3 / originaldepth;
        }


        if (calcultionmodel)
            baseGltf.traverse((child) => {
                if (child.type === "Object3D" || child.type == "Mesh") { // fenster: Object3D. regal: mesh
                    for (var i = 0; i < globalThis.calculationModel.node.length; i++) {
                        if (globalThis.calculationModel.node[i].name == child.name) {

                            eval("var param1 = " + param1 + ";")
                            eval("var param2 = " + param2 + ";")
                            eval("var param3 = " + param3 + ";")

                            child.position.x = eval(globalThis.calculationModel.node[i].x);
                            child.position.y = eval(globalThis.calculationModel.node[i].y);
                            child.position.z = eval(globalThis.calculationModel.node[i].z);
                            child.scale.x = eval(globalThis.calculationModel.node[i].scaleX);
                            child.scale.y = eval(globalThis.calculationModel.node[i].scaleY);
                            child.scale.z = eval(globalThis.calculationModel.node[i].scaleZ);

                            var b = new THREE.Box3().setFromObject(child);
                            if (b.min.x < bbox.min.x) bbox.min.x = b.min.x;
                            if (b.min.y < bbox.min.y) bbox.min.y = b.min.y;
                            if (b.min.z < bbox.min.z) bbox.min.z = b.min.z;
                            if (b.max.x > bbox.max.x) bbox.max.x = b.max.x;
                            if (b.max.y > bbox.max.y) bbox.max.y = b.max.y;
                            if (b.max.z > bbox.max.z) bbox.max.z = b.max.z;

                            // console.log(child.name, child, bbox)
                        }

                        // helpers
                        if (child.userData.type === "windowhelper" && originalwidth) {
                            child.scale.x = param1 / originalwidth;
                            child.scale.y = param2 / originalheight;
                            child.scale.z = param3 / originaldepth;
                        }
                    }


                }
            });

        // if (showhelper) {

        //     var bb = new THREE.Box3(new Vector3(bbox.min.x, bbox.min.y, bbox.min.z), new Vector3(bbox.max.x, bbox.max.y, bbox.max.z));
        //     var sbox = new THREE.Box3Helper(bb, new THREE.Color(0xff0000));

        //     scene.add(sbox);
        // }
    }




    public static createDmensionLabels(scene: THREE.Scene, object: any, walls: any) {

        // schnittpunkt zwischen objekt und Wänden in alle 4 Richtungen => Endpunkt bestimmen
        var wallmeshes = [];
        var toremove = [];
        var helpers = [];
        var roomheight = walls[0].h;

        scene.traverse(x => {
            if (x?.userData?.type === "wall") {
                wallmeshes.push(x);
            }
            if (x?.userData?.type === "dimensiongroup") {
                toremove.push(x);
            }
            if (x?.userData?.type === "cuthelper") {
                x.updateMatrixWorld();
                // x.parent.updateMatrixWorld();
                // x.parent.parent.updateMatrixWorld();
                helpers.push(x);
            }
        });
        for (var i = 0; i < toremove.length; i++)
            scene.remove(toremove[i]);
        if (!object) return;



        var x = object.position.x;
        var y = object.position.y;
        var z = object.position.z;
        var box = new THREE.Box3().setFromObject(object);
        var vec = new THREE.Vector3();
        var size = box.getSize(vec)
        var width = size.x;
        var depth = size.z;



        if (object.userData.type == "window" || object.userData.type == "door") {
            var wall = walls[object.userData.wallindex];
            var from = new THREE.Vector3(-wall.p1.z, y + 10, -wall.p1.x);
            var wallvec = new THREE.Vector3(-wall.p2.z + wall.p1.z, 0, -wall.p2.x + wall.p1.x).normalize();
            var raycaster = new THREE.Raycaster();
            raycaster.set(from, wallvec);
            var intersects = raycaster.intersectObject(object as any, true);
            if (intersects.length > 0) {
                for (var j = 0; j < 1; j++) {
                    //  if (intersects[j] == object) {
                    var text = Math.round(intersects[j].distance);
                    var to = intersects[j].point;
                    this.createDimensionLabel(scene, text, from, to);
                    //   }
                }
            }


            var from = new THREE.Vector3(-wall.p2.z, y + 10, -wall.p2.x);
            var wallvec = new THREE.Vector3(+wall.p2.z - wall.p1.z, 0, +wall.p2.x - wall.p1.x).normalize();
            var raycaster = new THREE.Raycaster();
            raycaster.set(from, wallvec);
            var intersects = raycaster.intersectObject(object as any, true);
            if (intersects.length > 0) {
                for (var j = 0; j < 1; j++) {
                    //  if (intersects[j] == object) {
                    var text = Math.round(intersects[j].distance);
                    var to = intersects[j].point;
                    this.createDimensionLabel(scene, text, from, to);
                    //   }
                }
            }


        }
        else { // furniture
            var raycaster = new THREE.Raycaster();
            var pos = object.position;
            if (object.userData.type == "lamp")
                pos.y = 10;
            raycaster.set(pos, new THREE.Vector3(1, 0.01, 0));
            var intersects = raycaster.intersectObjects(wallmeshes);
            if (intersects.length > 0) {

                intersects[0].point.y = roomheight;

                if (intersects.length > 0) {
                    this.createDimensionLabel(scene, Math.round(intersects[0].distance - width / 2), intersects[0].point, new THREE.Vector3(x + width / 2, roomheight, z));
                }
                var raycaster2 = new THREE.Raycaster();
                raycaster2.set(pos, new THREE.Vector3(-1, 0.01, 0));
                var intersects = raycaster2.intersectObjects(wallmeshes);
                if (intersects.length > 0) {
                    this.createDimensionLabel(scene, Math.round(intersects[0].distance - width / 2), intersects[0].point, new THREE.Vector3(x - width / 2, roomheight, z));
                }
                var raycaster3 = new THREE.Raycaster();
                raycaster3.set(pos, new THREE.Vector3(0, 0.01, 1));
                var intersects = raycaster3.intersectObjects(wallmeshes);
                if (intersects.length > 0) {
                    this.createDimensionLabel(scene, Math.round(intersects[0].distance - depth / 2), intersects[0].point, new THREE.Vector3(x, roomheight, z + depth / 2));
                }
                var raycaster4 = new THREE.Raycaster();
                raycaster4.set(pos, new THREE.Vector3(0, 0.01, -1));
                var intersects = raycaster4.intersectObjects(wallmeshes);
                if (intersects.length > 0) {
                    this.createDimensionLabel(scene, Math.round(intersects[0].distance - depth / 2), intersects[0].point, new THREE.Vector3(x, roomheight, z - depth / 2));
                }
            }
        }




    }

    public static createDimensionLabel(scene: THREE.Scene, text: any, from: THREE.Vector3, to: THREE.Vector3) {
        var mid = new Vector3(from.x + (to.x - from.x) / 2, from.y, from.z + (to.z - from.z) / 2); //clone(); // .addVectors(from, from.subVectors(from, to));

        var group = new THREE.Group();

        // https://www.npmjs.com/package/three.meshline
        const line = new MeshLine();
        const mm = new MeshLineMaterial({ lineWidth: 1, color: new THREE.Color(0xF08A00), depthTest: false, depthWrite: false });

        line.setPoints([from.x, from.y + 1, from.z, to.x, to.y + 1, to.z]);
        const mesh = new THREE.Mesh(line, mm);
        group.add(mesh);
        // const line2 = new MeshLine();
        // line2.setPoints([mid.x, mid.y + 150, mid.z, to.x, to.y + 150, to.z]);
        // const mesh2 = new THREE.Mesh(line2, mm);
        // group.add(mesh2);


        // https://github.com/vasturiano/three-spritetext
        var dimText = new SpriteText(text, 16, '#ffffff');
        dimText.borderWidth = 0.5;
        dimText.padding = 2;
        dimText.borderRadius = 2;
        dimText.borderColor = "#F08A00";
        dimText.backgroundColor = "#111111";
        dimText.material.depthTest = false;
        dimText.material.depthWrite = false;
        dimText.position.copy(mid);
        group.add(dimText);

        // endpunkte nicht erwünscht
        // var geometry = new THREE.SphereGeometry(5, 32, 16);
        // const material = new THREE.MeshBasicMaterial({ color: 0xF08A00, depthTest: false, depthWrite: false });
        // const sphere = new THREE.Mesh(geometry, material);
        // sphere.position.copy(from);
        // group.add(sphere);
        // var geometry3 = new THREE.SphereGeometry(5, 32, 16);
        // const sphere2 = new THREE.Mesh(geometry3, material);
        // sphere2.position.copy(to);
        // group.add(sphere2);

        // const line2 = new MeshLine();
        // line2.setPoints([mid.x, mid.y, mid.z, to.x, to.y, to.z]);
        // group.add(line2);

        group.userData.type = "dimensiongroup";
        scene.add(group);

    }




    // get largest of four variables
    public static getMax(a: number, b: number, c: number, d: number): number {
        var max = a;
        if (b > max)
            max = b;
        if (c > max)
            max = c;
        if (d > max)
            max = d;
        return max;
    }

    //  get smallest of four variables
    public static getMin(a: number, b: number, c: number, d: number): number {
        var min = a;
        if (b < min)
            min = b;
        if (c < min)
            min = c;
        if (d < min)
            min = d;
        return min;
    }



    public static getRoomBB(walls: any) {
        // get bounding box of all walls
        var minx = Infinity;
        var minz = Infinity;
        var maxx = -Infinity;
        var maxz = -Infinity;
        for (var i = 0; i < walls.length; i++) {
            var wall = walls[i];
            var minxw = ThreeUtils.getMin(wall.p1.x, wall.p2.x, wall.p3.x, wall.p4.x);
            var maxxw = ThreeUtils.getMax(wall.p1.x, wall.p2.x, wall.p3.x, wall.p4.x);
            var minzw = ThreeUtils.getMin(wall.p1.z, wall.p2.z, wall.p3.z, wall.p4.z);
            var maxzw = ThreeUtils.getMax(wall.p1.z, wall.p2.z, wall.p3.z, wall.p4.z);
            if (minxw < minx)
                minx = minxw;
            if (maxxw > maxx)
                maxx = maxxw;
            if (minzw < minz)
                minz = minzw;
            if (maxzw > maxz)
                maxz = maxzw;
        }
        var width = maxx - minx;
        var depth = maxz - minz;
        // get largest
        var largest = width;
        if (depth > largest) largest = depth;

        return { minx: minx, minz: minz, maxx: maxx, maxz: maxz, width: width, depth: depth, largest: largest };

    }


    public static isWireUno(products, product) {
        var providerid = product.elements[0].id;
        for (var i = 0; i < products.length; i++) {
            if (product.elements)
                for (var l = 0; l < products[i]?.elements.length; l++)
                    if (products[i]?.elements[l]?.provider == providerid) {
                        if (products[i]?.elements[l]?.mountingSurface?.type?.includes("uno"))
                            return true;
                    }


        }

        return false;
    }

    public static async createRopeSystem(gltfs, meshes, loader, scene, SERVERURL, products: any) {
        console.log('createRopeSystem', products);

        var dwl = "/products/Deckenwinkel_links.gltf";
        var dwr = "/products/Deckenwinkel_rechts.gltf";
        var bl = "/products/Befestigung_links.gltf";
        var br = "/products/Befestigung_rechts.gltf";
        var seil = "/products/seilstueck.gltf";
        var element = "/products/sh001hmh_120_40_8_weissgrau.gltf";

        for (var i = 0; i < products.length; i++) {
            var product = products[i];
            if (product.elements)
                // Seilsystem
                if (product.elements[0].wireLength) {
                    var rs = new THREE.Group();

                    // elemente auf Seilsystem
                    var providerid = product.elements[0].id;
                    var providedelements = [];
                    for (var y = 0; y < products.length; y++) {
                        for (var l = 0; l < products[y]?.elements.length; l++)
                            if (products[y]?.elements[l]?.provider == providerid) {
                                var newelement = JSON.parse(JSON.stringify(products[y]?.elements[l]));
                                newelement.gltffile = products[y].threeDModel.product;
                                newelement.productid = products[y].id
                                newelement.packindex = l;
                                providedelements.push(newelement);
                            }
                    }
                    var p = product;
                    var isW2W = false;
                    if (p.threeDModel.partleft.includes("Befestigung"))
                        isW2W = true;

                    var length = product.elements[0].wireLength + 32;// (test[0].elements[0] as any).wireLength;
                    if (isW2W)
                        length = length - 32 + 32;
                    //hack, da noch keine Zuordnung Seil<->Element
                    //var el = products[i + 1].threeDModel.product.split('_'); // elements sind hier alle Elemente des Seils
                    var el = providedelements[0].gltffile.split('_'); // elements sind hier alle Elemente des Seils
                    element = providedelements[0].gltffile;
                    //                test[1].threeDModel.product.split('_');
                    var elementwidth = parseInt(el[el.length - 3]) - 10;// ; // ösen je nach Element unterschiedlich
                    var elementlength = parseInt(el[el.length - 4]);
                    var elementheight = parseInt(el[el.length - 2]);
                    var width = elementwidth + 15; // + parseInt(el[3]) - 16; // + 16;
                    var isUno = ThreeUtils.isWireUno(products, product);

                    var center = { x: 0, y: 0, z: 0 };// ; // { x: 300, y: 344, z: 345 }
                    var groupcenter = { x: -product.elements[0].position.x + width / 2 * 0, y: product.elements[0].position.y, z: -product.elements[0].position.z + length / 2 };
                    var productpos = { x: product.elements[0].position.x, y: product.elements[0].position.y, z: product.elements[0].position.z };
                    // hack
                    // center.x += length / 2;
                    center.y -= 16;
                    var rotation = { x: 0, y: 0, z: 0 };


                    var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, seil, "produkt", false, center, rotation, 1, true, true, true, { product: p })).scene;
                    var userData = { product: p, type: "ropeEnd" };
                    if (isW2W) {
                        var positionl = { x: center.x - length / 2, y: center.y, z: center.z - width / 2 };
                        var positions = { x: center.x + length / 2 - 16, y: center.y, z: center.z - width / 2 };
                        var positionr = { x: center.x + length / 2, y: center.y, z: center.z - width / 2 };
                        if (isUno) {
                            positionl = { x: center.x - length / 2, y: center.y, z: center.z };
                            positions = { x: center.x + length / 2 - 16, y: center.y, z: center.z };
                            positionr = { x: center.x + length / 2, y: center.y, z: center.z };
                        }
                        var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, br, "ropeEnd", false, positionl, rotation, 1, true, true, true, userData)).scene;
                        rs.add(newgltf);
                        var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, bl, "ropeEnd", false, positionr, rotation, 1, true, true, true, userData)).scene;
                        rs.add(newgltf);
                        var userData = { product: p, type: "rope" };
                        var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, seil, "rope", false, positions, rotation, 1, true, true, true, userData)).scene;
                        newgltf.scale.set(length - 32, 1, 1);
                        rs.add(newgltf);

                    }
                    else {
                        var positionl = { x: center.x - length / 2, y: center.y + 16, z: center.z - width / 2 };
                        var positions = { x: center.x + length / 2 - 16, y: center.y, z: center.z - width / 2 };
                        var positionr = { x: center.x + length / 2, y: center.y + 16, z: center.z - width / 2 };
                        if (isUno) {
                            positionl = { x: center.x - length / 2, y: center.y + 16, z: center.z };
                            positions = { x: center.x + length / 2 - 16, y: center.y, z: center.z };
                            positionr = { x: center.x + length / 2, y: center.y + 16, z: center.z };
                        }

                        var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, dwr, "ropeEnd", false, positionl, rotation, 1, true, true, true, userData)).scene;
                        rs.add(newgltf);
                        var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, dwl, "ropeEnd", false, positionr, rotation, 1, true, true, true, userData)).scene;
                        rs.add(newgltf);
                        var userData = { product: p, type: "rope" };
                        var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, seil, "rope", false, positions, rotation, 1, true, true, true, userData)).scene;
                        newgltf.scale.set(length - 32, 1, 1);
                        rs.add(newgltf);
                    }


                    if (!isUno) {

                        if (isW2W) {
                            positionl = { x: center.x - length / 2, y: center.y, z: center.z + width / 2 };
                            positions = { x: center.x + length / 2 - 16, y: center.y, z: center.z + width / 2 };
                            positionr = { x: center.x + length / 2, y: center.y, z: center.z + width / 2 };
                            userData = { product: p, type: "ropeEnd" };
                            var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, br, "ropeEnd", false, positionl, rotation, 1, true, true, true, userData)).scene;
                            rs.add(newgltf);
                            var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, bl, "ropeEnd", false, positionr, rotation, 1, true, true, true, userData)).scene;
                            rs.add(newgltf);
                            userData = { product: p, type: "rope" };
                            var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, seil, "rope", false, positions, rotation, 1, true, true, true, userData)).scene;
                            newgltf.scale.set(length - 32, 1, 1);
                            rs.add(newgltf);
                        } else {

                            positionl = { x: center.x - length / 2, y: center.y + 16, z: center.z + width / 2 };
                            positions = { x: center.x + length / 2 - 16, y: center.y, z: center.z + width / 2 };
                            positionr = { x: center.x + length / 2, y: center.y + 16, z: center.z + width / 2 };
                            userData = { product: p, type: "ropeEnd" };
                            var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, dwr, "ropeEnd", false, positionl, rotation, 1, true, true, true, userData)).scene;
                            rs.add(newgltf);
                            var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, dwl, "ropeEnd", false, positionr, rotation, 1, true, true, true, userData)).scene;
                            rs.add(newgltf);
                            userData = { product: p, type: "rope" };
                            var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, seil, "rope", false, positions, rotation, 1, true, true, true, userData)).scene;
                            newgltf.scale.set(length - 32, 1, 1);
                            rs.add(newgltf);
                        }
                        // console.log('new rope', p);
                    }

                    for (var e = 0; e < providedelements.length; e++) {

                        var elementpos = JSON.parse(JSON.stringify(providedelements[e].position));
                        elementpos.y = - 20 + elementheight / 2; // TODO: ggf aus höhe
                        if (isUno)
                            elementpos.y = -18.7 - (elementwidth + 10) / 2;

                        elementpos.x = providedelements[e].position.z - productpos.z; // + length / 2; // + elementlength / 2);// providedelements[e].position.z; //100 * (e + 1);
                        elementpos.z = providedelements[e].position.x - productpos.x; // + width * 2; // -100;

                        var rotated = Utils.rotatePointY(elementpos.x, elementpos.z, product.elements[0].rotation * Math.PI / 180);
                        elementpos.x = rotated[0];
                        elementpos.z = rotated[1];


                        var posOnRope = elementpos.x;
                        var userDataElement = {
                            posOnRope: posOnRope, wireLength: length, elementpos: elementpos, elementindex: e, packindex: providedelements[e].packindex, elementlength: elementlength, elementwidth: elementwidth, product: p,
                            type: "element", rotation: rotation,
                            isUno: isUno,
                            startpos: { x: positionl.x, y: 16, z: 0 }, endpos: { x: positionr.x, y: 16, z: 0 },
                            rot: product.elements[0].rotation * Math.PI / 180,
                            element: providedelements[e], productpos: productpos
                        };

                        var elementfile = providedelements[e].gltffile;
                        var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, elementfile, "element", false, elementpos, { x: 0, y: Math.PI / 2, z: 0 }, 1, false, true, true, userDataElement)).scene;
                        var elementbb = ThreeUtils.getBBox(newgltf);

                        if (providedelements[e].isHidden)
                            newgltf.visible = false;
                        //    var newgltf = (await this.addGltf2Scene(gltfs, meshes, loader, scene, SERVERURL, element, "element", false, center, { x: 0, y: Math.PI / 2, z: 0 }, 1, true, true, true, userDataElement)).scene;
                        //  newgltf.position.sub(initpos);
                        //         newgltf.rotateY(product.elements[0].rotation * Math.PI / 180);
                        rs.add(newgltf);

                        const h = new THREE.BoxGeometry(10, 10, 10);
                        const m = new THREE.MeshBasicMaterial({ color: 0x440000, depthTest: false, depthWrite: false });
                        const c = new THREE.Mesh(h, m);
                        c.position.set(-providedelements[e].position.z, providedelements[e].position.y, -providedelements[e].position.x);
                        //         scene.add(c);

                        // console.log('new element', providedelements[e], providedelements[0].gltffile, width, elementbb.max.x - elementbb.min.x, elementpos.x, elementpos.z);
                    }

                    const geometry = new THREE.BoxGeometry(length, 40, width);
                    const material = new THREE.MeshPhongMaterial({ color: 0x00ff00, transparent: true, opacity: 0 });
                    const cube = new THREE.Mesh(geometry, material);
                    cube.userData.type = "produkt";
                    cube.userData.mountingSurface = "ceiling";

                    cube.position.set(-center.x, center.y, -center.z);
                    meshes.push(cube)
                    //   newgltf.rotateY(product.elements[0].rotation * Math.PI / 180);
                    rs.add(cube);

                    //    }
                    rs.userData = {
                        type: "produkt", mountingSurface: "ceiling", isRopeSystem: true, isW2W: isW2W, product: { id: product.id }, ropesystemwidth: width, ropesystemlength: length,
                        groupcenter: groupcenter, productpos: productpos, startpos: { x: positionl.x, y: 16, z: 0 }, endpos: { x: positionr.x, y: 16, z: 0 }, rot: product.elements[0].rotation * Math.PI / 180,
                    };
                    //    console.log('ropesystem newgltf', groupcenter, rs, rs.userData);
                    // rs.position.copy(new THREE.Vector3(groupcenter.x, groupcenter.y, groupcenter.z));
                    rs.rotateY(product.elements[0].rotation * Math.PI / 180);
                    rs.position.setX(-productpos.z);
                    rs.position.setY(productpos.y);
                    rs.position.setZ(-productpos.x);

                    //    rs.applyMatrix4(new THREE.Matrix4().makeTranslation(100, 0, 0));
                    //     rs.rotateOnAxis(new THREE.Vector3(0, 1, 0), -Math.PI / 12);

                    var pivot = new THREE.Group();
                    //  scene.add(pivot);
                    //                    pivot.rotation.y = -Math.PI / 5;
                    // pivot.position.setX(-productpos.z);
                    // pivot.position.setY(productpos.y);
                    // pivot.position.setZ(-productpos.x);
                    // pivot.add(rs);

                    // rs.rotateY(-Math.PI / 5);
                    rs.updateMatrix();

                    // const h = new THREE.BoxGeometry(10, 10, 10);
                    // const m = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
                    // const c = new THREE.Mesh(h, m);
                    // c.position.set(groupcenter.z, groupcenter.y, groupcenter.x);
                    // scene.add(c);
                    const h2 = new THREE.BoxGeometry(10, 10, 10);
                    const m2 = new THREE.MeshBasicMaterial({ color: 0xffff00 });
                    const c2 = new THREE.Mesh(h2, m2);
                    //c2.position.set(groupcenter.z - length / 2, groupcenter.y, groupcenter.x - width / 2*0);
                    c2.position.set(-productpos.z, productpos.y, -productpos.x);
                    //           scene.add(c2);

                    //                    rs.updateMatrixWorld(true);
                    // rs.updateWorldMatrix(true, true);
                    scene.add(rs);


                }
        }

        console.log('scene', scene);
        return rs;
    }


    public static async addGltf2Scene(gltfs: any, meshes: any, loader: any, scene: any, SERVERURL: string, filename: string, type: string, showhelper: boolean, position: any, rotation: any, scale: number = 1, castShadow = true, movable = false, collisioncheck = false, userdata: any = {}) {
        //   console.log('createInterior', filename, position, type)

        if (!filename.startsWith('http'))
            filename = SERVERURL + filename;

        var gltf = await (loader).loadAsync(filename);

        if (movable) {
            gltfs.push({ filename: filename, gltf: gltf });
        }
        var bbox = new THREE.Box3().setFromObject(gltf.scene);
        //     console.log('gltf', gltf)

        //  var gltf = Utils.cloneGltf(gltf2);
        gltf.scene.traverse((child) => {
            if ((child as any).isMesh) {
                (child as any).cursor = 'pointer';
                child.userData.type = "child_" + type;
                child.castShadow = castShadow;
                //   (child as any).geometry.center(); // center here
            }
            if (child.type == "Object3D") {

            }

            var node = child as any;
            // if (node.material && (node.material.isMeshStandardMaterial ||
            //     (node.material.isShaderMaterial && node.material.envMap !== undefined))) {
            //     if (!filename.includes('fenster')) {
            //         node.d.envMap = this.scene.environment;
            //         node.material.envMapIntensity = 0.4; // boombox seems too dark otherwise
            //         //    console.log(filename, 'node.material', node.material);
            //     }
            // }

            if ((child as any).isNode) {

            }
        });
        gltf.scene.position.set(-position.x, position.y, -position.z);
        gltf.scene.scale.set(scale, scale, scale);
        if (rotation?.x) gltf.scene.rotateX(rotation.x);
        if (rotation?.y) gltf.scene.rotateY(rotation.y);
        if (rotation?.z) gltf.scene.rotateZ(rotation.z);

        // if (type !== "camera")
        //     scene.add(gltf.scene);

        var t = type;
        gltf.scene.userData = userdata;
        if (type.includes('window') || type.includes('door')) {
            t = type.split('#')[0];
            gltf.scene.userData.wallindex = parseInt(type.split('#')[1]);
        }
        gltf.scene.userData.type = t;
        gltf.scene.userData.filename = filename;
        (gltf.scene as any).userData.movable = movable;

        // TODO: nur elternelment
        if (movable)
            meshes.push(gltf.scene);

        // if (collisioncheck) {
        //     var bbox = new THREE.Box3().setFromObject(gltf.scene);
        //     this.objectboxes.push(bbox);
        // }

        if ((type == "window" || type == "door") && showhelper) {
            var box3 = ThreeUtils.getBBox(gltf.scene);
            const dimensions = new THREE.Vector3().subVectors(box3.max, box3.min);
            const boxGeo = new THREE.BoxBufferGeometry(dimensions.x, dimensions.y, dimensions.z);
            const matrix = new THREE.Matrix4().setPosition(dimensions.addVectors(box3.min, box3.max).multiplyScalar(0.5));
            boxGeo.applyMatrix4(matrix);
            const mesh = new THREE.Mesh(boxGeo, new THREE.MeshBasicMaterial({ color: 0xffcc55, transparent: false, opacity: 0.5 }));
            mesh.renderOrder = 999;
            mesh.material.depthTest = false;
            mesh.material.depthWrite = false;
            mesh.userData.type = "windowhelper";
            mesh.visible = true;
            gltf.scene.add(mesh);
        }

        return gltf;
    }



    public static getOppositeCamera(viewpoints, obj, walls, scene, camera) {
        var objnormal = obj.userData.wallnormal;
        //    for (var i = 0; i < walls.length; i++) {
        var plane = new THREE.Plane(); //walls[i].userData.wallnormal, walls[i].userData.wallposition);
        plane.setFromCoplanarPoints(new THREE.Vector3(), new THREE.Vector3(1, 0, 0), new THREE.Vector3(0, 1, 0));
        //            (this.raycaster as THREE.Raycaster).ray.intersectPlane(this.plane, this.pointOfIntersection);
        //              wall[i].p1
        const raycaster = new THREE.Raycaster();
        raycaster.ray = new THREE.Ray(obj.position, new THREE.Vector3(-objnormal[0], 0, -objnormal[1]));
        const intersects = raycaster.intersectObjects(scene.children);
        var wallindex = 0;
        for (let i = 0; i < intersects.length; i++) {
            if (intersects[i].object.userData.type == "wall") {
                wallindex = intersects[i].object.userData.wallindex;
            }
        }
        return viewpoints[wallindex];
        //   }


    }


    wgroup: THREE.Group;
    create3DMarker(scene, box: THREE.Box3, length: number, width: number, gap: number) {
        var mat = new THREE.MeshPhongMaterial({ color: 0xf08a00 });//, transparent: false, opacity: 1, specular: 0xf08a00, emissive: 0xf08a00, shininess: 0 })
        var w = box.max.x - box.min.x;
        var h = box.max.y - box.min.y;
        var d = box.max.z - box.min.z;

        if (this.wgroup)
            scene.remove(this.wgroup);
        this.wgroup = new THREE.Group();

        var x1 = new THREE.BoxGeometry(length, width, width); var mx1 = new THREE.Mesh(x1, mat); this.wgroup.add(mx1);
        mx1.position.set(box.min.x + length / 2, box.min.y, box.min.z);
        var y1 = new THREE.BoxGeometry(width, length, width); var my1 = new THREE.Mesh(y1, mat); this.wgroup.add(my1);
        my1.position.set(box.min.x, box.min.y + length / 2, box.min.z);
        var z1 = new THREE.BoxGeometry(width, width, length); var mz1 = new THREE.Mesh(z1, mat); this.wgroup.add(mz1);
        mz1.position.set(box.min.x, box.min.y, box.min.z + length / 2);

        var x2 = new THREE.BoxGeometry(length, width, width); var mx2 = new THREE.Mesh(x2, mat); this.wgroup.add(mx2);
        mx2.position.set(box.max.x - length / 2, box.min.y, box.min.z);
        var y2 = new THREE.BoxGeometry(width, length, width); var my2 = new THREE.Mesh(y2, mat); this.wgroup.add(my2);
        my2.position.set(box.max.x, box.min.y + length / 2, box.min.z);
        var z2 = new THREE.BoxGeometry(width, width, length); var mz2 = new THREE.Mesh(z2, mat); this.wgroup.add(mz2);
        mz2.position.set(box.max.x, box.min.y, box.min.z + length / 2);

        var x3 = new THREE.BoxGeometry(length, width, width); var mx3 = new THREE.Mesh(x3, mat); this.wgroup.add(mx3);
        mx3.position.set(box.min.x + length / 2, box.max.y, box.min.z);
        var y3 = new THREE.BoxGeometry(width, length, width); var my3 = new THREE.Mesh(y3, mat); this.wgroup.add(my3);
        my3.position.set(box.min.x, box.max.y - length / 2, box.min.z);
        var z3 = new THREE.BoxGeometry(width, width, length); var mz3 = new THREE.Mesh(z3, mat); this.wgroup.add(mz3);
        mz3.position.set(box.min.x, box.max.y, box.min.z + length / 2);

        var x4 = new THREE.BoxGeometry(length, width, width); var mx4 = new THREE.Mesh(x4, mat); this.wgroup.add(mx4);
        mx4.position.set(box.max.x - length / 2, box.max.y, box.min.z);
        var y4 = new THREE.BoxGeometry(width, length, width); var my4 = new THREE.Mesh(y4, mat); this.wgroup.add(my4);
        my4.position.set(box.max.x, box.max.y - length / 2, box.min.z);
        var z4 = new THREE.BoxGeometry(width, width, length); var mz4 = new THREE.Mesh(z4, mat); this.wgroup.add(mz4);
        mz4.position.set(box.max.x, box.max.y, box.min.z + length / 2);

        // obenlinkshinten
        var x5 = new THREE.BoxGeometry(length, width, width); var mx5 = new THREE.Mesh(x5, mat); this.wgroup.add(mx5);
        mx5.position.set(box.min.x + length / 2, box.min.y, box.max.z);
        var y5 = new THREE.BoxGeometry(width, length, width); var my5 = new THREE.Mesh(y5, mat); this.wgroup.add(my5);
        my5.position.set(box.min.x, box.min.y + length / 2, box.max.z);
        var z5 = new THREE.BoxGeometry(width, width, length); var mz5 = new THREE.Mesh(z5, mat); this.wgroup.add(mz5);
        mz5.position.set(box.min.x, box.min.y, box.max.z - length / 2);

        var x6 = new THREE.BoxGeometry(length, width, width); var mx6 = new THREE.Mesh(x6, mat); this.wgroup.add(mx6);
        mx6.position.set(box.max.x - length / 2, box.min.y, box.max.z);
        var y6 = new THREE.BoxGeometry(width, length, width); var my6 = new THREE.Mesh(y6, mat); this.wgroup.add(my6);
        my6.position.set(box.max.x, box.min.y + length / 2, box.max.z);
        var z6 = new THREE.BoxGeometry(width, width, length); var mz6 = new THREE.Mesh(z6, mat); this.wgroup.add(mz6);
        mz6.position.set(box.max.x, box.min.y, box.max.z - length / 2);

        var x7 = new THREE.BoxGeometry(length, width, width); var mx7 = new THREE.Mesh(x7, mat); this.wgroup.add(mx7);
        mx7.position.set(box.min.x + length / 2, box.max.y, box.max.z);
        var y7 = new THREE.BoxGeometry(width, length, width); var my7 = new THREE.Mesh(y7, mat); this.wgroup.add(my7);
        my7.position.set(box.min.x, box.max.y - length / 2, box.max.z);
        var z7 = new THREE.BoxGeometry(width, width, length); var mz7 = new THREE.Mesh(z7, mat); this.wgroup.add(mz7);
        mz7.position.set(box.min.x, box.max.y, box.max.z - length / 2);

        var x8 = new THREE.BoxGeometry(length, width, width); var mx8 = new THREE.Mesh(x8, mat); this.wgroup.add(mx8);
        mx8.position.set(box.max.x - length / 2, box.max.y, box.max.z);
        var y8 = new THREE.BoxGeometry(width, length, width); var my8 = new THREE.Mesh(y8, mat); this.wgroup.add(my8);
        my8.position.set(box.max.x, box.max.y - length / 2, box.max.z);
        var z8 = new THREE.BoxGeometry(width, width, length); var mz8 = new THREE.Mesh(z8, mat); this.wgroup.add(mz8);
        mz8.position.set(box.max.x, box.max.y, box.max.z - length / 2);

        scene.add(this.wgroup);
    }



    public static toScreenPosition(obj: THREE.Object3D, camera: any, renderer: THREE.WebGLRenderer, controls: any) {

        var viewcevtor = camera.position.clone().sub(obj.position).normalize();
        viewcevtor.y = 0;
        camera.position.y = 165;
        //  camera.position.x = viewpoint.position.x;
        //  camera.position.z = viewpoint.position.z;
        camera.up = new THREE.Vector3(0, 1, 0)
        var lookatx = camera.position.x - viewcevtor.x;
        var lookatz = camera.position.z - viewcevtor.z;
        if (controls) {
            // controls.target = new THREE.Vector3(viewcevtor.x, camera.position.y, viewcevtor.z);

            controls.target = new THREE.Vector3(lookatx, camera.position.y, lookatz);
            camera.fov = 100;
            controls.update();

            //console.log('set camera', viewpoint, this.controls.position, this.controls.target)
        }


        // var vector = new THREE.Vector3();

        // var widthHalf = 0.5 * renderer.getContext().canvas.width;
        // var heightHalf = 0.5 * renderer.getContext().canvas.height;

        // obj.updateMatrixWorld();
        // vector.setFromMatrixPosition(obj.matrixWorld);
        // vector.project(camera);

        // vector.x = (vector.x * widthHalf) + widthHalf;
        // vector.y = - (vector.y * heightHalf) + heightHalf;

        // return {
        //     x: vector.x,
        //     y: vector.y
        // };

    };

}

export { ThreeUtils };